import axios from 'axios';
import store from '@/store'; // Adjust the path as necessary

export async function submitToAPI() {
    const user = store.state.user;
    const selectedPlatforms = store.getters['platforms/selectedPlatforms'];
    const config = store.state.config;

    // Prepare the payload
    const payload = {
        user,
        platforms: selectedPlatforms,
        api_version: config.apiVersion,
        tpsp_name: config.tpspName,
        finio_product_valuations: config.finioProductValuations,
        finio_product_transactions: config.finioProductTransactions,
        finio_product_history: config.finioProductHistory,
        finio_product_income_statements: config.finioProductIncomeStatements,
    };

    // Check if we're in development mode (localhost or local IP)
    const isDevelopment = window.location.hostname === 'localhost' ||
                         window.location.hostname.startsWith('192.168') ||
                         window.location.hostname.startsWith('127.0.');

    // Determine API URL
    const apiUrl = isDevelopment
        ? '/api/post-form-tpsp.php'  // Will be proxied to localhost:8000
        : 'https://finio.sprintenterprise.co.uk/api/post-form-tpsp.php';

    // Log frontend payload in development
    if (isDevelopment) {
        console.log('==========================================');
        console.log('🧪 LOCAL DEVELOPMENT MODE');
        console.log('==========================================');
        console.log('Full Payload:', JSON.stringify(payload, null, 2));
        console.log('\n--- Platform Credentials Detail ---');
        selectedPlatforms.forEach(p => {
            console.log(`\nPlatform: ${p.name} (${p.id})`);
            if (p.credentials) {
                console.log('Credentials:', p.credentials);
            }
            console.log('Validation State:', {
                credentials_valid: p.credentials_valid,
                authorisation_confirmed: p.authorisation_confirmed
            });
        });
        console.log('==========================================');
        console.log('Calling local PHP API at:', apiUrl);
        console.log('Check Network tab → Response for Zoho payload');
        console.log('==========================================');
    }

    try {
        const response = await axios.post(apiUrl, payload);

        // Log response in development only
        if (isDevelopment) {
            console.log('API Response:', response.data);
        }

        return response.data;
    } catch (error) {
        console.error('API Error:', error);
        throw error;
    }
}